import { MenuItem } from '@hive/component';
import { IsFavoriteIcon } from '@hive/core/components/pure/icons';
import { CompatibleFavoriteItemsAdapter } from '@hive/core/modules/favorite';
import { useI18n } from '@hive/i18n';
import { useLiveData, useService } from '@toeverything/infra';
import { useMemo } from 'react';

export const FavoriteFolderOperation = ({ id }: { id: string }) => {
  const t = useI18n();
  const compatibleFavoriteItemsAdapter = useService(
    CompatibleFavoriteItemsAdapter
  );

  const favorite = useLiveData(
    useMemo(() => {
      return compatibleFavoriteItemsAdapter.isFavorite$(id, 'folder');
    }, [compatibleFavoriteItemsAdapter, id])
  );

  return (
    <MenuItem
      prefixIcon={<IsFavoriteIcon favorite={favorite} />}
      onClick={() => compatibleFavoriteItemsAdapter.toggle(id, 'folder')}
    >
      {favorite
        ? t['com.hive.rootAppSidebar.organize.folder-rm-favorite']()
        : t['com.hive.rootAppSidebar.organize.folder-add-favorite']()}
    </MenuItem>
  );
};
